<template>
  <div :class="$style.whats_new">
    <div :class="$style.title">What's New</div>
    <div :class="$style.news_area">
      <table>
        <tr>
          <td>LookMe</td>
          <td>{{ input_date.lookme }}に更新しました</td>
        </tr>
        <tr>
          <td>お客様の声</td>
          <td>{{ input_date.customer }}に更新しました</td>
        </tr>
        <tr>
          <td>夢郵便</td>
          <td>{{ input_date.dream }}に更新しました</td>
          <!-- {{ input_date.dream }} -->
          <!-- <td>2020-04-18に更新しました</td> -->
        </tr>
        <tr>
          <td>松井秀喜の言葉</td>
          <td>{{ input_date.saying }}まで追加しました</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
// import hlist from "@/assets/json/saying/sentiment.json";

export default Vue.extend({
  name: "WhatsNew",
  // data() {
    // return { hlist };
  // },
  props: {
    input_date: {
      type: Object,
    },
  },
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  .whats_new {
    height: 50px;
    width: 230px;
    background: rgba(#333333, 0.7);
    padding: 0px 10px;
    color: #fff;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    .title {
      margin-top: 3px;
      font-size: 12px;
    }
    .news_area {
      height: 20px;
      table {
        font-size: 10px;
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;
        tr {
          display: block;
          width: inherit;
          height: inherit;
          left: 100%;
          position: absolute;
          animation: slideNews 16s ease infinite;
          &:nth-child(1) {
            animation-delay: 0s;
          }
          &:nth-child(2) {
            animation-delay: 4s;
          }
          &:nth-child(3) {
            animation-delay: 8s;
          }
          &:nth-child(4) {
            animation-delay: 12s;
          }
        }
      }
      @keyframes slideNews {
        0% {
          left: 100%;
        }
        3% {
          left: 0;
        }
        22% {
          left: 0;
        }
        30% {
          left: -100%;
        }
        100% {
          left: -100%;
        }
      }
    }
  }
}

@media only screen and (min-width: 1024px) {
  .whats_new {
    // height: 200px;
    background: rgba(#403f3f, 0.7);
    color: #fff;
    padding: 10px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    .title {
      font-size: 20px;
      text-align: center;
      border-bottom: 1px solid #fff;
      padding-bottom: 5px;
    }
    .news_area {
      margin: 0px 20px;
      margin-top: 5px;
      table {
        font-size: 14px;
        tr {
          height: 30px;
          td {
            min-width: 160px;
          }
        }
      }
    }
  }
}
</style>
